import React from "react";

// Import Images
import CountIcon1 from "../assets/images/count-icon1.png";
import CountIcon2 from "../assets/images/count-icon2.png";
import selectedBg from "../assets/images/selectedBg.png";
// User images
import user1 from "../assets/images/test1.png";
import user2 from "../assets/images/test2.png";
import user3 from "../assets/images/test3.png";
import user4 from "../assets/images/us2.png";
import user5 from "../assets/images/us3.png";

const StudentsSelected = () => {
  const students = [user1, user2, user3, user4, user5, user1, user2];

  return (
    <div className="selected-Student">
    <div className="students-wrapper" style={{
        backgroundImage: `url(${selectedBg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        borderRadius: '5px',
        padding:'20px 0',
        border: '1px solid #DDDEE2',
      }}>
      <div className="text-center">
        <h2 className="fw-bolder d-flex justify-content-center align-items-center">
          <img
            src={CountIcon1}
            alt=""
            className="studentCount me-2"
          />
          <span>50,240</span>
          <img
            src={CountIcon2}
            alt=""
            className="studentCount ms-2"
          />
        </h2>

        <h4 className="fw-bold">Students Selected</h4>

        <p className="fw-medium w-50 mx-auto">
        Lorem Ipsum is simply dummy text of the type setting dummy text dummy text industry dummy text.
        </p>

        <div className="d-flex justify-content-center gap-2">
          {students.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="student"
              className="student-avatarr"
            />
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default StudentsSelected;
